import React, { Component } from "react";
import { PageHeader, Modal, Spin, Alert, Result } from "antd";
import ButtonItem from "../../../Components/ButtonItem";
import { Tabs } from "antd5";
import {
  ContactsFilled,
  FormatPainterFilled,
  ExclamationCircleOutlined,
  LayoutFilled,
  KeyOutlined,
  SettingOutlined,
  MailOutlined,
  CarOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import VentaOnlineConfiguracion from "./VentaOnlineConfiguracion/VentaOnlineConfiguracion";
import AparienciaConfiguracion from "./AparienciaConfiguracion/AparienciaConfiguracion";
import ContactoConfiguracion from "./ContactoConfiguracion/ContactoConfiguracion";
import PaginasConfiguracion from "./PaginasConfiguracion/PaginasConfiguracion";
import InsumosConfiguracion from "./InsumosConfiguracion/InsumosConfiguracion";
import ApisConfiguracion from "./ApisConfiguracion/ApisConfiguracion";
import EnviosConfiguracion from "./EnviosConfiguracion/EnviosConfiguracion";
import CorreosConfiguracion from "./CorreosConfiguracion/CorreosConfiguracion";
import DashboardConfiguracion from "./DashboardConfiguracion/DashboardConfiguracion";
import { tabStyles } from "../../../Components/TabbedDynamicTable";
import axios from "axios";
import { connect } from "react-redux";

class ConfiguracionEcommerce extends Component {
  state = {
    activeKey: "1",
    configExiste: false,
    loadingInit: true,
    modoDemo: false,
    ventaOnline: false,
  };


  ventaOnlineRef = React.createRef();
  aparienciaRef = React.createRef();
  contactoRef = React.createRef();
  paginasRef = React.createRef();
  insumosRef = React.createRef();
  apisRef = React.createRef();
  enviosRef = React.createRef();
  correosRef = React.createRef();
  dashboardRef = React.createRef();

  componentDidMount() {
   if (this.props.permisoAccesoEcommerce) {
      this.verificarExistenciaConfig();
    } else {
      this.setState({ loadingInit: false });
    }
  }

  verificarExistenciaConfig = () => {
    const { empresaId, headersToken } = this.props;

    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionApariencia",
        { empresaId },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          const data = res?.data?.data;
          const esDemo = !data?._id;
          
          this.setState({
            configExiste: true,
            ventaOnline: res.data.ventaOnline,
            modoDemo: esDemo,
          });
        } else {
          this.setState({ configExiste: false, modoDemo: false });
        }
      })
      .catch(() => {
        this.setState({ configExiste: false });
      })
      .finally(() => {
        this.setState({ loadingInit: false });
      });
  };

  handleConfigCreada = () => {
    this.setState({
      configExiste: true,
      modoDemo: false,
    });
  };

  onTabClick = (newKey) => {
    const { activeKey } = this.state;
    if (newKey === activeKey) return;

    let currentComponent;
    if (activeKey === "1") currentComponent = this.aparienciaRef.current;
    else if (activeKey === "2") currentComponent = this.ventaOnlineRef.current;
    else if (activeKey === "3") currentComponent = this.paginasRef.current;
    else if (activeKey === "4") currentComponent = this.insumosRef.current;
    else if (activeKey === "5") currentComponent = this.apisRef.current;
    else if (activeKey === "6") currentComponent = this.enviosRef.current;
    else if (activeKey === "7") currentComponent = this.contactoRef.current;
    else if (activeKey === "8") currentComponent = this.correosRef.current;
    else if (activeKey === "9") currentComponent = this.dashboardRef.current;

    const hayCambios =
      currentComponent &&
      currentComponent.tieneCambios &&
      currentComponent.tieneCambios();

    if (hayCambios) {
      Modal.confirm({
        title: "Tienes cambios sin guardar",
        icon: <ExclamationCircleOutlined />,
        content: "¿Deseas guardar los cambios antes de cambiar de pestaña?",
        okText: "Guardar y Cambiar",
        cancelText: "Descartar",
        centered: true,
        onOk: () => {
          return currentComponent.guardarDesdePadre().then((exito) => {
            if (exito) {
              this.setState({ activeKey: newKey });
            }
          });
        },
        onCancel: () => {
          if (currentComponent && currentComponent.descartarCambios) {
            currentComponent.descartarCambios();
          }
          this.setState({ activeKey: newKey });
        },
      });
    } else {
      this.setState({ activeKey: newKey });
    }
  };

  render() {
    const { permisoAccesoEcommerce } = this.props;
    const { configExiste, loadingInit, activeKey, ventaOnline } = this.state;

    const linkDemo = "https://tienda.biwo.mx/"; 

    if (!permisoAccesoEcommerce || !ventaOnline) {
      return (
        <div
          style={{
            backgroundColor: "white",
            padding: "40px",
            borderRadius: "8px",
            minHeight: "80vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Result
            status="403"
            title="Tu empresa aún no cuenta con el módulo E-Commerce"
            subTitle="Para más información de como obtenerlo contacta con tu vendedor para una cotización. Revisa la demostración a continuación."
            extra={
              <ButtonItem type="primary" href={linkDemo} target="_blank">
                Ir a ver demo
              </ButtonItem>
            }
          />
         {
          <div
            style={{
              width: "100%",
              maxWidth: "1500px",
              height: "600px",
              border: "1px solid #f0f0f0",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              marginTop: "20px",
            }}
          >
            <iframe
              src={linkDemo}
              title="Vista Previa Demo"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>
          }
        </div>
      );
    }

    const tabItems = [
      {
        label: (
          <span>
            <FormatPainterFilled />
            Apariencia
          </span>
        ),
        key: "1",
        children: (
          <AparienciaConfiguracion
            ref={this.aparienciaRef}
            onConfigSaved={this.handleConfigCreada}
          />
        ),
      },
      {
        label: (
          <span>
            <SettingOutlined /> Ajustes ERP
          </span>
        ),
        key: "2",
        disabled: !configExiste || this.state.modoDemo,
        children: <VentaOnlineConfiguracion ref={this.ventaOnlineRef} />,
      },
      {
        label: (
          <span>
            <LayoutFilled /> Páginas
          </span>
        ),
        key: "3",
        disabled: !configExiste || this.state.modoDemo,
        children: <PaginasConfiguracion ref={this.paginasRef} />,
      },
      {
        label: (
          <span>
            <LayoutFilled /> Insumos
          </span>
        ),
        key: "4",
        disabled: !configExiste || this.state.modoDemo,
        children: <InsumosConfiguracion ref={this.insumosRef} />,
      },  
      {
        label: (
          <span>
            <KeyOutlined /> Cobro
          </span>
        ),
        key: "5",
        disabled: !configExiste || this.state.modoDemo,
        children: <ApisConfiguracion ref={this.apisRef} />,
      },
      {
        label: (
          <span>
            <CarOutlined /> Envíos
          </span>
        ),
        key: "6",
        disabled: !configExiste || this.state.modoDemo,
        children: <EnviosConfiguracion ref={this.enviosRef} />,
      },
      {
        label: (
          <span>
            <ContactsFilled />
            Contacto
          </span>
        ),
        key: "7",
        disabled: !configExiste || this.state.modoDemo,
        children: <ContactoConfiguracion ref={this.contactoRef} />,
      },
      {
        label: (
          <span>
            <MailOutlined /> Correos
          </span>
        ),
        key: "8",
        disabled: !configExiste || this.state.modoDemo,
        children: <CorreosConfiguracion ref={this.correosRef} />,
      },
      {
        label: (
          <span>
            <DashboardOutlined /> Dashboard
          </span>
        ),
        key: "9",
        disabled: !configExiste || this.state.modoDemo,
        children: <DashboardConfiguracion ref={this.dashboardRef} />,
      },
    ];

    return (
      <>
        <PageHeader
          title="Configuración eCommerce"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div
          style={{
            backgroundColor: "white",
            padding: 20,
            paddingTop: 5,
            borderRadius: 6,
          }}
        >
          <Spin spinning={loadingInit}>
            {this.state.modoDemo && (
              <Alert
                message="Configuración por defecto"
                description="Actualmente estás viendo la configuración predeterminada. Realiza cualquier cambio y guarda para personalizar tu tienda."
                type="warning"
                showIcon
                closable
                style={{ marginBottom: 20, marginTop: 20 }}
              />
            )}
            <Tabs
              activeKey={activeKey}
              items={tabItems}
              onTabClick={this.onTabClick}
              className="custom-tabs"
            />
            <style>{tabStyles}</style>
          </Spin>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  empresaId: state.empresa.id,
  headersToken: state.user.headersToken,
  permisoAccesoEcommerce:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "697e2c2db47586150a762dc9",
    )?.activado,
});

export default connect(mapStateToProps)(ConfiguracionEcommerce);
